<script setup lang="ts">
import BootstrapCard from '@/components/bootstrap/BootstrapCard.vue';
import MfaEnable from '@/pages/(home)/account/content/mfa.enable.vue';

definePage({ name: 'AccountMfaEnable', meta: { title: 'account.enableApp' } });
</script>

<template>
  <Suspense>
    <MfaEnable />

    <template #fallback>
      <BootstrapCard :shimmer="true" :shimmer-height="300" :header-text="$t('account.enableApp')" />
    </template>
  </Suspense>
</template>

<style scoped>

</style>